import { render, staticRenderFns } from "./UprateReport.vue?vue&type=template&id=4c49dfa0&"
import script from "./UprateReport.vue?vue&type=script&lang=js&"
export * from "./UprateReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports